module.exports = __webpack_public_path__ + "static/media/purple-tile-wide.544cb140.png";